export default __webpack_public_path__ + "static/media/phone.d4a0d7e5.svg";